export const SSFlags = {
  free5ctQuiz: 'free-5ct-quiz',
  simplifiedBaBexperiment: 'simplified_bab_experiment',
  subAndSaveExperiment: 'sub_and_save_experiment',
  fullSubscriptionStackExperiment: 'full_subscription_stack_experiment',
  newNavTest: 'new_nav_test',
  enableAuNz: 'enable_au_nz'
} as const;
type SSFlagLabel = keyof typeof SSFlags;
export type SSFlagValue = (typeof SSFlags)[SSFlagLabel];

export const SSParams = {
  [SSFlags.free5ctQuiz]: {
    enableAbandonmentFlow: 'enableAbandonmentFlow'
  },
  [SSFlags.simplifiedBaBexperiment]: {
    hasSimplifiedBaB: 'hasSimplifiedBaB'
  },
  [SSFlags.subAndSaveExperiment]: {
    hasSubAndSave: 'hasSubAndSave'
  },
  [SSFlags.fullSubscriptionStackExperiment]: {
    fullSubscriptionStackParam: 'fullSubscriptionStackParam'
  },
  [SSFlags.newNavTest]: {
    enableNewNav: 'enableNewNav'
  }
} as const;

export const SSGates = {
  sierraChatRollout: 'sierra-chat-rollout',
  blockPrepaidCards: 'block-prepaid-cards',
  disableSoldOutBanner: 'disable_sold_out_banner',
  showSelfMigrationBanner: 'show_self_migration_banner',
  showCancelationV53UpgradeBanner: 'show_cancelation_v53_upgrade_flow',
  downgradeContactSupportBanner: 'downgrade_contact_support_banner',
  enableShopAllAddToCart: 'enable-shop-all-add-to-cart',
  v53SwapProduct: 'show_swap_product_v53',
  enableNewReviewsUI: 'enable-new-reviews-ui',
  agzModal: 'agz-modal',
  enableAGZ: 'enable_agz',
  enableFlavorSelection: 'enable_bab_new_flavor',
  enableNewFlavorsModal: 'enable_new_flavors_modal'
} as const;

type SSGateLabel = keyof typeof SSGates;
export type SSGateValue = (typeof SSGates)[SSGateLabel];
